<template>
	<b-container fluid id="userPermModalContent">

		<b-row v-if="departmentsForTree.length > 0">
			<b-col>
				<!-- TREE VIEW -->
				<ul>
					<li class="row">
						<div class="col-6 justify-content-between customPaddingCol" style="font-size: 1rem;">
							<span>
								<i class="fa fa-building" style="color: #F0D45F; padding-right: 3px;"></i>{{$t('employees.departments')}}
							</span>
						</div>
						<div class="col-3 noPaddingCol"><i class="fa fa-unlock-alt" style="padding-right: 3px;"></i>{{$t('actions.management-department')}}</div>
						<div class="col-3 noPaddingCol"><i class="fa fa-unlock-alt" style="padding-right: 3px;"></i>{{$t('actions.management-transfer')}}</div>
					</li>
					<template v-for="dep in departmentsForTree">
						<department-tree-for-user
							@depChanged="departmentChanged"
							@transferChanged="transferChanged"
							class="item"
							:key="dep.id + 'dep'"
							:model="dep"
							:selectedDepartmentIds="selectedDepartmentIds"
							:selectedTransferDepartmentIds="selectedTransferDepartmentIds">
						</department-tree-for-user>
					</template>
				</ul>
				<!-- TREE VIEW -->
			</b-col>
		</b-row>
		<!-- SHOW WHEN THERE IS NO DEPARTMENTS BEGIN -->
		<b-row v-else>
			<h4 style="font-size: 1.1rem">Hozircha bo'limlar qo'shilmagan</h4>
			<p>Qo'shish uchun <strong>Bo'limlar</strong> sahifasiga o'ting.</p>
		</b-row>
		<!-- SHOW WHEN THERE IS NO DEPARTMENTS END -->

		<b-row align-h="end" align-v="end">
			<b-col cols="4">
				<b-button size="sm" variant="outline-danger" block @click="emitCloseUserPermModal">
					{{$t('actions.cancel')}}
				</b-button>
			</b-col>
			<b-col cols="4">
				<b-button :disabled="departmentsForTree.length <= 0" size="sm" variant="outline-success" block @click="emitUserPermSave">
					{{$t('actions.save')}}
				</b-button>
			</b-col>
		</b-row>

	</b-container>
</template>

<script>
	import { mapGetters } from 'vuex'
	import DepartmentTreeForUser from './DepartmentTreeForUser'
    export default {
        name: "UserPermissionsModal",
		components: {DepartmentTreeForUser},
		props: {
        	departmentsForTree: {
        		type: Array,
				default: []
			},
			isModalOpened: {
        		type: Boolean,
				default: false
			}
		},

		data: () => {
			return {
				selectedDepartmentIds: [],
				selectedTransferDepartmentIds: []
			}
		},

		computed: {
			...mapGetters('users', [
				'permittedDepIds', 'permittedTransferIds'
			])
		},
		watch: {
        	'isModalOpened': {
        		handler () {
        			this.selectedDepartmentIds = [];
        			this.selectedTransferDepartmentIds = []
				}
			},
        	'permittedDepIds': {
        		handler () {
					this.selectedDepartmentIds = this.permittedDepIds ? this.permittedDepIds.slice() : [];
				}
			},
			'permittedTransferIds': {
        		handler () {
					this.selectedTransferDepartmentIds = this.permittedTransferIds ? this.permittedTransferIds.slice() : [];
				}
			}
		},

		/**
		 * Methods
		 */
		methods: {
			departmentChanged (newVal, oldVal) {
				if (newVal) {
					if (!this.selectedDepartmentIds.includes(newVal)) {
						this.selectedDepartmentIds.push(newVal);
					}
				} else {
					let index = this.selectedDepartmentIds.indexOf(oldVal);
					if (index > -1) {
						this.selectedDepartmentIds.splice(index, 1);
					}
				}
			},
			transferChanged (newVal, oldVal) {
				if (newVal) {
					if (!this.selectedTransferDepartmentIds.includes(newVal)) {
						this.selectedTransferDepartmentIds.push(newVal)
					}
				} else {
					let index = this.selectedTransferDepartmentIds.indexOf(oldVal);
					if (index > -1) {
						this.selectedTransferDepartmentIds.splice(index, 1);
					}
				}
			},
			emitCloseUserPermModal () {
				this.$emit('closeUserPermModal');
			},
			emitUserPermSave () {
				let payload = {
					permittedDepartmentIds: this.selectedDepartmentIds,
					transferPermittedDepartmentIds: this.selectedTransferDepartmentIds
				};
				this.$emit('savePermittedData', payload);
			}
		},
    }
</script>

<style lang="scss">
	#userPermModalContent {
		padding: 0 15px;
		ul {
			line-height: 1.5em;
			list-style-type: none;
		}
		.customPaddingCol {
			padding: 0;
			span {
				display: inline-block;
			}

		}
		.noPaddingCol {
			padding: 0 0 0 12px;
			font-size: .8rem;
		}
	}
</style>
